<app-filter-panel [quickSearchFilter]="filters.name" quickSearchPlaceholder="Nombre" (search)="search()"></app-filter-panel>

<!--
<div class="flex gap-2 cola-4">
    <span class="w-full input-field p-input-icon-right">
        <input pInputText placeholder="Nombre" [(ngModel)]="filters.name.value" (keydown.enter)="search()"
            class="w-full" />
        <i *ngIf="filters.name.value" class="pi pi-times cursor-pointer"
            (click)="filters.name.value = null; search()"></i>
    </span>
</div>
-->

<p-table #grid [value]="casesLogTypes" [lazy]="true" (onLazyLoad)="loadData($event)" [loading]="loading"
    [paginator]="true" [rows]="25" [totalRecords]="totalRecords" [showCurrentPageReport]="true"
    currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
    [rowsPerPageOptions]="[25,100,250]" [scrollable]="true" scrollHeight="flex" paginatorDropdownAppendTo="body">
    <ng-template pTemplate="header" let-columns>
        <tr>
            <th width="30">Icono</th>
            <th pSortableColumn="name">Nombre <p-sortIcon field="name"></p-sortIcon></th>
            <th pSortableColumn="isGeneric" width="200">Todas las empresas <p-sortIcon field="isGeneric"></p-sortIcon></th>
            <th pSortableColumn="revisionRequired" width="200">Requiere revisión <p-sortIcon field="revisionRequired"></p-sortIcon></th>
            <th width="100"></th>
        </tr>   
    </ng-template>
    <ng-template pTemplate="body" let-caseLogType let-columns="columns">
        <tr (dblclick)="edit(caseLogType)">
            <td>
                <i [ngClass]="caseLogType.iconClass"></i>
            </td>
            <td>{{caseLogType.name}}</td>
            <td>                
              <i class="pi" [ngClass]="{ 'text-green-500 pi-check-circle': caseLogType.isGeneric, 'text-red-500 pi-times-circle': !caseLogType.isGeneric }"></i>
            </td>
            <td>                
              <i class="pi" [ngClass]="{ 'text-green-500 pi-check-circle': caseLogType.revisionRequired, 'text-red-500 pi-times-circle': !caseLogType.revisionRequired }"></i>
            </td>
            <td>
                <div class="flex gap-2 justify-content-end">
                    <p-button *ngIf="allowDelete" (click)="delete(caseLogType)" [rounded]="true" [text]="false"
                        severity="danger"><i class="pi pi-trash"></i></p-button>
                    <p-button *ngIf="allowWrite" (click)="edit(caseLogType)" [rounded]="true" [text]="false"><i
                            class="pi pi-pencil"></i></p-button>
                </div>
            </td>
        </tr>
    </ng-template>
</p-table>

<p-confirmDialog></p-confirmDialog>